<template>
  <div>
    <d-table
      v-if="tableReady"
      tableName="international_shipments"
      :data_object="data_object"
      :getFreshData="true"
      :table_title="tableTitle"
      :linkClick="linkClick"
      :link="link"
      :mobileBreakpoint="'0'"
      :onDataReceived="onDataReceived"
      :getRowClass="getRowClass"
      :coloredFields="coloredFields"
      :getItemColor="getItemColor"
      :itemsPerPage="100"
      :filterCondition="filterCondition"
      :searchableColumns="searchableColumns"
      :hasSearch="true"
      :hasAdvancedSearch="true"
      ref="dTable"
      :key="tableKey"
      :serverPagination="false"
      :remoteSearch="false"
      :showGroupBy="true"
      v-bind="vBind"
      :noDelete="noDelete"
      :toolBarControls="toolBarControls"
      :toolbarRight="true"
      :defaultTabCaption="defaultTabCaption"
      :columnTool="true"
      :defaultTabColor="defaultTabColor"
      :noTabs="noTabs"
      :noGroups="noGroups"
    />
    <!-- <v-alert
      class="ma-4"
      dismissible
      timeout="3000"
      v-if="successMessage != '' && !noAlert"
      type="success"
    >
      {{ successMessage }}
    </v-alert> -->
    <v-snackbar
      v-if="successMessage != '' && !noAlert"
      v-model="successMessage"
      :timeout="3000"
      color="success"
    >
      {{ successMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="successMessage = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-alert
      class="ma-4"
      timeout="3000"
      dismissible
      v-if="errorMessage != '' && errorMessage"
      type="error"
    >
      {{ errorMessage }}
    </v-alert>
  </div>
</template>
<script>
import DTable from "../components/Table";
import axios from "axios";
import * as fun from "../plugins/common";

export default {
  components: { DTable },
  props: {
    searchInput: String,
  },
  data() {
    return {
      tblClass: "",
      successMessage: "",
      errorMessage: "",
      tableKey: 0,
      tableReady: false,
      getFreshData: true,
      link: {
        field: "shipment_id",
        name: "shipment",
      },
      latestDate: null,
      data_object: {
        object_name: "international_shipment",

        // date_fields: ["latest_date"],

        mobileBreakpoint: 0,
        all_records: true,
        // additional_data: [
        //   { obj_name: "service_type" },
        //   { obj_name: "lead_status" },
        //   { obj_name: "stage" },
        //   { obj_name: "company" },
        // ],

        // item_key: "shipment_id",
        table_title: "International Shipments",
        hasSearch: true,
      },
      // coloredFields: ["service_type", "booked", "lead_status", "company_name"],
      serviceTypes: [],
      leadStatus: [],
      company: [],
      stages: [],
      filterTabs: [],
      originalRecords: [],
      searchableColumns: [],
      vBind: {},
      selectRecords: false,
      plansSelected: [],
      toolBarControls: [],
      showSalesPersonList: 0,
      showAssignButton: false,
      salesPerson: "",
      currentUser: "",
      noDelete: true,
      date: "",

      defaultTabColor: "success",

      noTabs: false,
      noGroups: false,

      dateQry: null,
    };
  },
  mounted() {
    var that = this;
    this.date = fun.formatDate(new Date(), true, null, true);
    this.latestDate = { $gte: this.date };
    // this.getQry();
    // this.$root.$on("customBtnClick", (f) => {
    //   if (f.btn == "assignSales") {
    //     that.showSales();
    //   }
    //   if (f.btn == "archive") {
    //     that.archive(f);
    //   }
    // });
    // this.$root.$on("tableFilterChanged", (t) => {
    //   // console.log(t);
    //   if (t.tableName == "shipments") {
    //     if (t.currentFilter == 1 || t.currentFilter == 0) {
    //       // that.showAssignButton = true;
    //       t.toolBarControls[0]["v-bind"].hidden = false;
    //     } else {
    //       // that.showAssignButton = false;
    //       t.toolBarControls[0]["v-bind"].hidden = true;
    //     }
    //   }
    // });
    //tableFilterChanged

    this.tableReady = true;
    // this.$root.$on("tableSelectionChanged", (t) => {
    //   if (!t.selectDelete) {
    //     that.plansSelected = t.selected;
    //   }
    // });
    this.toolBarControls = [];

    // this.toolBarControls.push({
    //   comp: "v-btn",
    //   id: "archive",
    //   "v-bind": {
    //     color: "warning",
    //     text: true,
    //     icon: "mdi-archive",
    //     "input-value": "Past Shipments",
    //   },
    // });
  },

  methods: {
    linkClick: function(item) {
      this.$root.addResentTab(item);
    },

    getRowClass(item) {
      return "";
    },
  },
  watch: {},
};
</script>
<style scoped>
.v-tab {
  background-color: white;
  margin: 1px !important;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  border: solid 1px;
}
</style>
